import BaseView from '../../../js/base-view';

const SELECTOR_ADVERTISING = '[data-advertising]';
const CLASS_HAS_AD = 'has-da';

export default class ArticleList extends BaseView {
	init() {
		this.refs = {
			advertising: this.el.querySelector(SELECTOR_ADVERTISING),
		};

		this.onAdLoaded = this.onAdLoaded.bind(this);
		this.onAdEmpty = this.onAdEmpty.bind(this);

		this.on('ad:loaded', SELECTOR_ADVERTISING, this.onAdLoaded);
		this.on('ad:empty', SELECTOR_ADVERTISING, this.onAdEmpty);
	}

	onAdLoaded() {
		this.el.classList.add(CLASS_HAS_AD);
	}

	onAdEmpty() {
		this.el.classList.remove(CLASS_HAS_AD);
	}
}
